export const STORAGE_KEY = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
};

export enum E_Route {
  AuthBegin = '/auth/login',
  AuthFailed = '/auth/failed',
  AuthContinue = '/auth/continue',
  Home = '/',
  Transcript = '/transcripts',
  Todos = '/todos',
  Media = '/media',
  Done = '/done',
  ManageCredits = '/manage-credits',
  ManageBilling = '/settings/manage-billing',
  MyAccount = '/settings/my-account',
  Notifications = '/settings/notifications',
  Services = '/settings/services',
  HowWeUseGmail = '/how-we-manage-your-inbox',
  Meeting = '/meeting',
  Podcast = '/podcast',
  Activity = '/activity',
  Settings = '/settings',
  MeetingBotSetting = '/settings/meeting-assistant',
  Calendar = '/calendar',
  Onboarding = '/onboarding',
  Warning = '/integration-info',
  MeetingTranscript = '/transcript',
}
